import { useState } from "react";
import { useDispatch } from "react-redux";

import { bulkApproveAdminEventRequestsRequest } from "../../../../../../store/AdminEventRequests/actions";

const useAdminReactivateRequests = ({
  rows,
  selectedIds,
  listParams,
  setSelectedIds,
  onRefreshEvent,
  reactivateCopy,
}) => {
  const dispatch = useDispatch();
  const [reactivateTargetIds, setReactivateTargetIds] = useState([]);
  const reactivateApplicants = rows.filter((row) =>
    reactivateTargetIds.includes(row.id),
  );

  const openReactivateModal = () => {
    setReactivateTargetIds(selectedIds);
  };

  const closeReactivateModal = () => {
    setReactivateTargetIds([]);
  };

  const confirmReactivate = () => {
    const isBulk = reactivateTargetIds.length > 1;

    dispatch(
      bulkApproveAdminEventRequestsRequest({
        eventRequestIds: reactivateTargetIds,
        listParams,
        successTitle: isBulk
          ? reactivateCopy?.bulkSuccessTitle
          : reactivateCopy?.successTitle,
        successBody: isBulk
          ? reactivateCopy?.bulkSuccessBody
          : reactivateCopy?.successBody,
        onSuccess: () => {
          setSelectedIds([]);
          setReactivateTargetIds([]);
          onRefreshEvent?.({ silent: true });
        },
      }),
    );
  };

  return {
    reactivateApplicants,
    isReactivateModalOpen: reactivateTargetIds.length > 0,
    openReactivateModal,
    closeReactivateModal,
    confirmReactivate,
  };
};

export default useAdminReactivateRequests;
